// extracted by mini-css-extract-plugin
export var container = "_x-0";
export var disabled = "_x-4";
export var fullWidth = "_x-3";
export var lined = "_x-1";
export var selected = "_x-5";
export var tab = "_x-2";